import { render } from "./SearchForm.vue?vue&type=template&id=54e323c5&scoped=true"
import script from "./SearchForm.vue?vue&type=script&lang=js"
export * from "./SearchForm.vue?vue&type=script&lang=js"

import "./SearchForm.vue?vue&type=style&index=0&id=54e323c5&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\LG\\Documents\\repositories\\opac\\search\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e323c5"]])

export default __exports__